require '../transforms/array-of-objects'
backgroundStyle = require 'utils/background-style-prop'

###
# Модель блюда
###
App.Dish = DS.Model.extend
  menu_order    : DS.attr 'number'
  can_zoom      : DS.attr 'boolean'
  description   : DS.attr 'string'
  ingredients   : DS.attr 'string'
  is_hidden     : DS.attr 'boolean'
  is_next_day   : DS.attr 'boolean'
  next_day_hour_count : DS.attr 'number'
  is_bonus_only : DS.attr 'boolean'
  no_bonus_accrue : DS.attr 'boolean'
  dont_discount : DS.attr 'boolean'
  name          : DS.attr 'string'
  options       : DS.attr 'arrayOfObjects'
  photo         : DS.attr 'mixed'
  price         : DS.attr 'string'
  weight        : DS.attr 'number'
  weight_unit   : DS.attr 'string'
  cooking_time  : DS.attr 'number'
  cooking_line  : DS.attr 'number'
  is_popular    : DS.attr 'boolean'
  required      : DS.attr 'boolean'
  metric             : DS.attr 'boolean'
  price_weight_unit  : DS.attr 'string'
  min_qty            : DS.attr 'number'
  delta_qty          : DS.attr 'number'
  excise_unit        : DS.attr 'string'
  ingredients        : DS.attr 'string'
  calories           : DS.attr 'number'
  proteins           : DS.attr 'number'
  fats               : DS.attr 'number'
  carbs              : DS.attr 'number'

  # Внешние связи
  category      : DS.belongsTo 'category',     async: true
  organization  : DS.belongsTo 'organization', async: true

  smallSquareBackground: backgroundStyle('photo.small_square')
  mediumSquareBackground: backgroundStyle('photo.medium_square')

  availabilityAvailable: Em.computed.equal('availability.status', 'available')
  availabilityProblem: Em.computed.not('availabilityAvailable')
  availabilityText: (->
    {'available':  Em.I18n.t('available.available'), 'not_available': Em.I18n.t('available.not_available'), 'call': Em.I18n.t('call')}[@get('availability.status')]
  ).property('availability')

  restaurantAvailability: ((key, value) ->
    # value = value + ''
    @set('availability', value) if arguments.length > 1
    @get('availability')
  ).property('availability')

  restaurantPrice: (->
    return @get('availability.price') if @get('availability.price')
    @get('price')
  ).property('price','availability')

  restaurantOptions: (->
    return @get('availability.options') if @get('availability.options')
    @get('options')
  ).property('options','availability')

  restaurantIsHidden: (->
    @get('availability.is_hidden') if @get('availability.is_hidden')
  ).property('is_hidden','availability')

